<template>
  <div></div>
</template>

<script>
  export default {
    layout: 'sidebar',
    created() {
      console.log(123456)
    },
    data() {
        return {}
    },
    mounted() {
    },
    computed: {},
    methods: {},
    destroyed() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// pages/index.vue